/*
  Automatic free gift sync for the cart.
  Reads the gift rules from #FreeGiftConfig (rendered in snippets/cart-drawer.liquid),
  then keeps the gift lines in the cart in line with the eligible products:
  - adds the matching gift for every eligible product (quantity x gift quantity)
  - updates the gift quantity when the product quantity changes
  - removes the gift when the product is removed or no longer eligible
  Gift lines carry the hidden line item property "_free_gift".
*/
(function () {
  if (window.__freeGiftInit) return;
  window.__freeGiftInit = true;

  var GIFT_PROPERTY = '_free_gift';
  var nativeFetch = window.fetch.bind(window);
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cartUrlPattern = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  var syncing = false;
  var pending = false;
  var timer = null;

  function readConfig() {
    var el = document.getElementById('FreeGiftConfig');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.warn('[FreeGift] Invalid config', e);
      return null;
    }
  }

  function isGiftLine(item) {
    return !!(item.properties && item.properties[GIFT_PROPERTY]);
  }

  function skuMatches(sku, trigger) {
    if (!sku || !trigger) return false;
    var s = String(sku).toLowerCase();
    var t = String(trigger).toLowerCase();
    if (s === t) return true;
    if (t.charAt(t.length - 1) === '.' || t.charAt(t.length - 1) === '-') return s.indexOf(t) === 0;
    return s.indexOf(t + '.') === 0;
  }

  function desiredGifts(cart, config) {
    var wanted = {};
    if (!config || !config.enabled) return wanted;
    cart.items.forEach(function (item) {
      if (isGiftLine(item)) return;
      for (var i = 0; i < config.rules.length; i++) {
        var rule = config.rules[i];
        if (skuMatches(item.sku, rule.trigger)) {
          var id = String(rule.gift);
          wanted[id] = (wanted[id] || 0) + item.quantity * rule.qty;
          break;
        }
      }
    });
    return wanted;
  }

  function postJson(url, body) {
    return nativeFetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw data;
        return data;
      });
    });
  }

  function getCart() {
    return nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function refreshCartUI() {
    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
      return Promise.resolve();
    }
    return nativeFetch(root + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        var parser = new DOMParser();
        var drawerHolder = document.getElementById('CartDrawer');
        if (drawerHolder && sections['cart-drawer']) {
          var drawerDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
          var newDrawer = drawerDoc.querySelector('#CartDrawer');
          if (newDrawer) drawerHolder.innerHTML = newDrawer.innerHTML;
          var drawerEl = document.querySelector('cart-drawer');
          var newDrawerEl = drawerDoc.querySelector('cart-drawer');
          if (drawerEl && newDrawerEl) {
            drawerEl.classList.toggle('is-empty', newDrawerEl.classList.contains('is-empty'));
            var overlay = drawerEl.querySelector('#CartDrawer-Overlay');
            if (overlay && typeof drawerEl.close === 'function') {
              overlay.addEventListener('click', drawerEl.close.bind(drawerEl));
            }
          }
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var bubbleDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
          var section = bubbleDoc.querySelector('.shopify-section');
          if (section) bubble.innerHTML = section.innerHTML;
        }
      })
      .catch(function (e) {
        console.warn('[FreeGift] Could not refresh cart', e);
      });
  }

  function sync() {
    if (syncing) {
      pending = true;
      return Promise.resolve();
    }
    syncing = true;
    var config = readConfig();
    var changed = false;

    return getCart()
      .then(function (cart) {
        var wanted = desiredGifts(cart, config);
        var updates = {};
        var seen = {};

        cart.items.forEach(function (item) {
          if (!isGiftLine(item)) return;
          var id = String(item.variant_id);
          var target = 0;
          if (!seen[id]) {
            target = wanted[id] || 0;
            seen[id] = true;
          }
          if (item.quantity !== target) updates[item.key] = target;
        });

        var toAdd = [];
        Object.keys(wanted).forEach(function (id) {
          if (!seen[id] && wanted[id] > 0) {
            var props = {};
            props[GIFT_PROPERTY] = '1';
            toAdd.push({ id: Number(id), quantity: wanted[id], properties: props });
          }
        });

        var chain = Promise.resolve();
        if (Object.keys(updates).length) {
          changed = true;
          chain = chain.then(function () {
            return postJson('cart/update.js', { updates: updates });
          });
        }
        if (toAdd.length) {
          chain = chain.then(function () {
            return postJson('cart/add.js', { items: toAdd })
              .then(function () {
                changed = true;
              })
              .catch(function (e) {
                console.warn('[FreeGift] Gift could not be added', e);
              });
          });
        }
        return chain;
      })
      .then(function () {
        if (changed) return refreshCartUI();
      })
      .catch(function (e) {
        console.warn('[FreeGift] Sync failed', e);
      })
      .then(function () {
        syncing = false;
        if (pending) {
          pending = false;
          scheduleSync();
        }
      });
  }

  function scheduleSync() {
    clearTimeout(timer);
    timer = setTimeout(sync, 150);
  }

  function isCartMutation(url, method) {
    if (!url) return false;
    var u = String(url);
    return cartUrlPattern.test(u) && String(method || 'GET').toUpperCase() === 'POST';
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url;
    var method = (init && init.method) || (input && input.method) || 'GET';
    var result = nativeFetch(input, init);
    if (isCartMutation(url, method)) {
      result.then(scheduleSync, scheduleSync);
    }
    return result;
  };

  var nativeOpen = XMLHttpRequest.prototype.open;
  var nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__freeGiftWatch = isCartMutation(url, method);
    return nativeOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__freeGiftWatch) this.addEventListener('loadend', scheduleSync);
    return nativeSend.apply(this, arguments);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync);
  } else {
    scheduleSync();
  }
})();
